module.exports = __webpack_public_path__ + "media/icons/next-48dd0d10.svg";